import styled from 'styled-components';
import { ColorsTypes } from '~/ui/theme/colors';

type BadgeProps = { palette?: ColorsTypes; bg?: string; text?: string };

// Maps the legacy static-scale palette keys (carried by comment type metadata) to the
// dark-theme-aware semantic color groups. The badge background uses the group's `secondary`
// (tinted surface) and the text uses `primaryAlt` (strong on-tint foreground).
const PALETTE_TO_SEMANTIC: Record<string, string> = {
  gray: 'neutral',
  success: 'positive',
  error: 'negative',
  warning: 'alert',
  info: 'info',
  primary: 'brand',
};

function resolvePalette(theme: any, palette?: ColorsTypes) {
  const group = (palette && PALETTE_TO_SEMANTIC[palette as string]) || 'neutral';
  const colorGroup = theme.colors?.[group];
  // A tag cinza (Privado RA) usa o tom `secondaryAlt`, um pouco mais claro que `secondary`,
  // para não sumir sobre superfícies escuras.
  const bg = group === 'neutral' ? colorGroup?.secondaryAlt : colorGroup?.secondary;
  return {
    bg,
    text: colorGroup?.primaryAlt,
  };
}

export const Badge = styled.span<BadgeProps>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
  width: fit-content;
  background: ${({ theme, palette, bg }) => bg || resolvePalette(theme, palette).bg};
  color: ${({ theme, palette, text }) => text || resolvePalette(theme, palette).text};

  svg {
    height: 12px;
    width: auto;
    flex-shrink: 0;
  }
`;
